export interface Ok<T> {
  value: T;
}

export interface Err {
  errors: string[];
}

export type Result<T> = Ok<T> | Err;

export function isError<T>(result: Ok<T> | Err): result is Err {
  return 'errors' in result;
}

export function isOk<T>(result: Ok<T> | Err): result is Ok<T> {
  return 'value' in result;
}
